<template>
  <div :style="`width: ${isCollapse ? '64px' : '100%'}; ${isCollapse ? 'transition: width 0.3s ease;' : 'transition: width 0.3s ease 0.3s;'} display: flex; align-items: center; position: relative;`">
    <el-menu
      :default-active="$route.name"
      class="el-menu-vertical-demo"
      @select="handleSelect"
      :collapse="isCollapse"
      style="position: relative;"
    >
      <el-menu-item
        index="users"
        v-can="'user.view'"
      >
        <i class="el-icon-user"></i>
        <span>Felhasználók</span>
      </el-menu-item>
      <el-menu-item
        index="user-categories"
        route="users/categories"
        v-can="'usercategory.view'"
      >
        <i class="el-icon-copy-document"></i>
        <span>Csoportok</span>
      </el-menu-item>
      <el-menu-item
        index="roles"
        v-can="'role.view'"
      >
        <i class="el-icon-lock"></i>
        <span>Jogkörök</span>
      </el-menu-item>
    </el-menu>
    <el-button
      :icon="isCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-left'"
      circle
      size="mini"
      :style="`position: absolute; right: 0; transform: translateX(50%) translateY(-50%); top: 50%; ${isCollapse ? 'transform: rotateZ(180deg) translate(-50%, 50%);' : ''} ${isCollapse ? 'transition: 0.3s;' : 'transition: 0.3s ease 0.3s;'} `"
      @click="handleCollapse"
    ></el-button>
  </div>
</template>
<script>
  export default {
    computed: {
      isCollapse() {
        return this.$store.getters['sidebar/isUserSidebarCollapse'];
      },
    },
    methods: {
      handleSelect(page) {
        switch (page) {
          case 'users':
            return this.$router.push('/' + page);
          case 'roles':
            return this.$router.push('/' + page);
          case 'user-categories':
            return this.$router.push('/users/categories');
        }
      },
      handleCollapse() {
        if(this.isCollapse) {
          this.$store.commit('sidebar/setIsUserSidebarCollapse', false);
        } else {
          this.$store.commit('sidebar/setIsUserSidebarCollapse', true) ;
        }
      }
    }
  };
</script>

<style scoped>
  .el-menu-vertical-demo > .el-menu-item.is-active {
    border-right: 2px solid #409EFF;
    transition: 0.3s;
    background: #ecf5ff;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
  }
</style>
